import { useContext, useState } from 'react';
import { GuildContext } from '../../../utils/contexts/GuildContext';
import { Spinner } from '../../../components/misc/Spinner'
import { useNavigate } from "react-router-dom";
import { MoonLoader } from 'react-spinners';
import { BsFillArrowLeftCircleFill } from 'react-icons/bs'
import styles from './index.module.scss'
import { Notification } from '../../../components/misc/Notification';
import { useFetchControl } from '../../../utils/hooks/useFetchControl';
import { PostControl } from '../../../utils/post/postControl';

const MenuPage = () => {
  const [postLoading, setPostLoading] = useState(false)
  const [postDone, setPostDone] = useState(false)

  const { guild } = useContext(GuildContext);
  const { control, loading } = useFetchControl(guild?.id)

  const navigate = useNavigate()

  if (loading) return <Spinner children={<MoonLoader size={40} color="white" />} />

  // console.log(control)

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setPostLoading(true)

    console.log(e.target.control.value)

    PostControl(guild?.id, e.target.control.value).then(async () => {
      await setPostDone(true)
      await setPostLoading(false)
      await setTimeout(() => setPostDone(false), 5000);
    })
    
  };
  
  return (
    <div>
      <div className="page">
        <div className={styles.container}>
          <div className={styles.flex}>
            <h1>Change bot language:</h1>
            <div onClick={() => navigate('/dashboard/categories')}>
              <BsFillArrowLeftCircleFill size={35} color="#ffffff"/>
            </div>
          </div>

          <form className={styles.form} onSubmit={handleSubmit}>
          <select name="control" className={styles.selector}>
            <option value="enable" selected={control?.playerControl === "enable" ? true : false}>Enable</option>
            <option value="disable" selected={control?.playerControl === "disable" ? true : false}>Disable</option>
          </select>
            
            <br/>
            <div className={styles.inputflex}>
              <button className={styles.summit} type="submit">Update</button>
              <button className={styles.summit} type="submit" >Cancel</button>
              <div>
                { postLoading ? <MoonLoader size={35} color="white" /> : <></> }
              </div>
            </div>
          </form>
        </div>
      </div>

      <div>
        { 
          postDone ? 
            <Notification 
              title="Done!" 
              description="Your server control has been successfully updated!"
            /> 
          : <></> 
        }
      </div>
    </div>
  )
}

export default MenuPage